async function safeExecute<T>(
  callback: () => Promise<T> | T,
  defaultReturn?: T,
): Promise<T | undefined> {
  try {
    return await callback();
  } catch (err) {
    return defaultReturn;
  }
}

export default safeExecute;
